<template>

		<div ref="msgBoxDiv" style="background:#FFFFFF;padding:10px;height:170px;width:260px;border :solid 1px black;position:absolute;">

			<div style="color:red; white-space: pre-wrap;">{{message}}</div>
			<center>
			<div><br>
			
			<input type="input" class="input" v-model="value">
			<br><br>
			<input type="button" :value=btn1Title class="button" @click='returnResult( MSG_BOX_OK )'>
			<input type="button" :value=btn2Title class="button" @click='returnResult( MSG_BOX_NG )'>
			</div>
			</center>
		</div>

</template>


<script>

import { ref, onMounted } from 'vue'

export default ({
  name: 'InputMsgBox',
  props:{
    targetElement:Object,
    message:String,
    btn1Title:String,
    btn2Title:String
  },
  setup(props, context){
    const MSG_BOX_OK = "OK"
    const MSG_BOX_NG = "NG"
    
    console.log("setup")
    const value = ref("")
    const msgBoxDiv = ref(null)
    
    onMounted(()=>{
      console.log( props.targetElement.getBoundingClientRect() )
      msgBoxDiv.value.style.left = props.targetElement.getBoundingClientRect().left + "px";
      
      msgBoxDiv.value.style.top = props.targetElement.getBoundingClientRect().top + props.targetElement.getBoundingClientRect().height + "px";
    })
    
    
    const returnResult = ( result ) => {
      console.log( result)
      context.emit( 'returnAction', result, value.value )
    }
    return{
      msgBoxDiv,
      returnResult,
      MSG_BOX_OK,
      MSG_BOX_NG,
      value
    }
  }
})


</script>